/* eslint-disable no-unused-vars */
/* eslint-disable no-lone-blocks */
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import ReactHtmlParser from "react-html-parser";
import ReactImageUploading from "react-images-uploading";
import ReactPaginate from "react-paginate";

/* MATERIAL TAILWIND COMPONENTS */
import {
  Button,
  Dialog,
  DialogBody,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from "@material-tailwind/react";

/* ICONS */
import { HiOutlineDotsVertical } from "react-icons/hi";
import { IoClose } from "react-icons/io5";
import { AiFillPlusCircle } from "react-icons/ai";
import { FiTrash } from "react-icons/fi";
import { GrPrevious, GrNext } from "react-icons/gr";

/* TOAST NOTIFICATION */
import { toast } from "react-toast";

/* REDUX IMPORTS */
import { useSelector } from "react-redux";

/* FORM CONTROL */
import { useFormik } from "formik";
import * as yup from "yup";

/* USER DEFINED COMPONENTS */
import Input from "../../../components/input";
import {
  addCategory,
  getCategoryList,
} from "../../../service/api/category.api";
import data from "../../../data/career";
import { handleAddToken } from "../../../service/request";
/* IMPORTED APIs */

/* STATUS */
const status = [
  { label: "Active", value: 1 },
  { label: "Inactive", value: 0 },
  { label: "Clear Filters", value: "clear" },
];

/* YES OR NO OPTIONS */
const options = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

/* Validation Schema */
// Validation Schema For Career Add Form
const validationSchemaForCareerAdd = yup.object().shape({
  name: yup.string().required("Career Name is required."),
  loaction: yup.string().required("Location Name is required."),
  description: yup.mixed(),
});

const Career = () => {
  // GLOBAL VARIABLES
  const userDetails = useSelector((state) => state?.user);

  // STATE VARIABLES
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(12);
  const [careerList, setCarrerList] = useState([]);
  const [totalDocs, setTotalDocs] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const [search, setSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  /* MODAL STATES */
  const [addDialog, setAddDialog] = useState(false);
  const [addCareerFormLoading, setAddCareerFormLoading] = useState(false);

  const [editDialog, setEditDialog] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editCareerFormLoading, setEditCareerFormLoading] = useState(false);

  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [viewDialog, setViewDialog] = useState(false);
  const [viewDetails, setViewDetails] = useState(null);

  /* CATEGORY BOX */
  const CareerBox = (props) => {
    return (
      <div className="bg-white rounded-lg border border-authBorder">
        <div className="p-5">
          <div className="flex items-center justify-between">
            <h5 className="text-lg font-proxima-bold text-black ">
              {props.name}
            </h5>

            <Menu placement="right">
              <MenuHandler>
                <Button className="p-[0.5vh] shadow-none hover:shadow-none bg-white rounded-full border border-authBorder hover:border-logoYellow transition-all duration-300 ease-in-out">
                  <HiOutlineDotsVertical className="w-4 h-4 text-black" />
                </Button>
              </MenuHandler>
              <MenuList className="p-2">
                <MenuItem
                  className="text-sm font-proxima-semibold text-black"
                  onClick={() => setEditDialog(!editDialog)}
                >
                  Edit career
                </MenuItem>
                <MenuItem
                  className="text-sm font-proxima-semibold text-black"
                  onClick={() => {
                    setViewDetails(props.details);
                    setViewDialog(!viewDialog);
                  }}
                >
                  View career
                </MenuItem>
                <MenuItem
                  className="text-sm font-proxima-semibold text-black"
                  onClick={() => {
                    setDeleteId(props.id);
                    setDeleteDialog(!deleteDialog);
                  }}
                >
                  Delete career
                </MenuItem>
              </MenuList>
            </Menu>
          </div>
          <div className="mt-2">
            <h7 className="text-sm font-proxima-regular text-greyText ">
              {props.details.description}
            </h7>
            <div className="flex items-center gap-2 mt-2">
              {props?.enabled ? (
                <Button className="shadow-none hover:shadow-none px-4 py-2 rounded-md border border-green-500 bg-green-500 transition-all duration-300 ease-in-out text-white font-proxima-semibold text-xs normal-case leading-none font-medium">
                  Enabled
                </Button>
              ) : (
                <Button
                  className="shadow-none hover:shadow-none px-4 py-2 rounded-md bg-white border border-authBorder hover:bg-green-500 hover:bg-opacity-10 hover:border-green-500 transition-all duration-300 ease-in-out text-black hover:text-green-500 font-proxima-semibold text-xs normal-case leading-none font-medium"
                  onClick={() => enableCareer(props.details)}
                >
                  Enable
                </Button>
              )}

              {!props?.enabled ? (
                <Button className="shadow-none hover:shadow-none px-4 py-2 rounded-md border border-red-500 bg-red-500 transition-all duration-300 ease-in-out text-white font-proxima-semibold text-xs normal-case leading-none font-medium">
                  Disabled
                </Button>
              ) : (
                <Button
                  className="shadow-none hover:shadow-none px-4 py-2 rounded-md bg-white border border-authBorder hover:bg-red-500 hover:bg-opacity-10 hover:border-red-500 transition-all duration-300 ease-in-out text-black hover:text-red-500 font-proxima-semibold text-xs normal-case leading-none font-medium"
                  onClick={() => disableCareer(props.details)}
                >
                  Disable
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Formik Function For Add Category
  const addCareerFormik = useFormik({
    initialValues: {
      name: "",
      location: "",
      description: "",
    },
    validationSchema: validationSchemaForCareerAdd,
    onSubmit: (values) => {
      console.log(values);
      const formData = new FormData();

      formData.append("name", values?.name);
      formData.append("location", values?.location);
      formData.append("isMenu", values?.isMenu?.value === "yes" ? true : false);
      formData.append(
        "isFeatured",
        values?.isFeatured?.value === "yes" ? true : false
      );
      if (values?.description) {
        formData.append(
          "description",
          draftToHtml(convertToRaw(values?.description?.getCurrentContent()))
        );
      }

      setAddCareerFormLoading(true);
      addCategory(formData)
        .then((res) => {
          if (res?.status) {
            toast.success(res?.message);
            addCareerFormik.handleReset();
            setAddDialog(false);
          } else {
            console.log(res?.message);
            toast.error(res?.message);
          }
        })
        .catch((e) => {
          setAddCareerFormLoading(false);
          toast.error(e?.response?.data?.message);
        })
        .finally((res) => {
          careerGetFunction();
          setAddCareerFormLoading(false);
        });
    },
  });

  // Functions
  const careerGetFunction = async () => {
    const obj = {
      page,
      sizePerPage,
      pagination: true,
    };
    if (search) {
      obj.search = search;
    }
    if (selectedStatus) {
      obj.status = selectedStatus?.value;
    }
    await handleAddToken(userDetails?.token);
    setLoading(true);
    getCategoryList(obj)
      .then((response) => {
        if (response?.status) {
          console.log("response", response);
          // setCareerList(response?.data?.docs);
          setTotalDocs(response?.data?.totalDocs);
          setTotalPages(response?.data?.totalPages);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  /* DISABLE CATEGORY FUNCTION */
  const disableCareer = (object) => {
    const obj = {
      name: object?.name,
      location: object?.location,
      status: 0,
    };
    if (object?.description) {
      obj.description = object?.description;
    }
    editCareerDetailsById(object?._id, obj)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message);
        } else {
          console.log(res?.message);
          toast.error(res?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally((res) => {
        careerGetFunction();
      });
  };

  /* ENABLE CATEGORY FUNCTION */
  const enableCareer = (object) => {
    const obj = {
      name: object?.name,
      location: object?.location,

      status: 1,
    };
    if (object?.description) {
      obj.description = object?.description;
    }

    editCareerDetailsById(object?._id, obj)
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message);
        } else {
          console.log(res?.message);
          toast.error(res?.message);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message);
      })
      .finally((res) => {
        careerGetFunction();
      });
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setLoading(true);
    setCareerList([]);
    setPage(selectedPage);
  };

  /* USE-EFFECTS */
  useEffect(() => {
    careerGetFunction();
  }, [page, sizePerPage, selectedStatus, search]);

  return (
    <section className="px-0 py-2 xl:p-10 lg:p-10 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Career | CIDA Perfumes</title>
      </Helmet>

      <div className="container-full-width">
        {/* HEADING */}
        <div className="block xl:flex lg:flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-proxima-bold text-black tracking-tight">
              Career
            </h1>
            <h2 className="text-base xl:text-lg lg:text-lg font-proxima-regular text-greyText">
              Manage the Career currently present on the website
            </h2>
          </div>

          <div className="block xl:flex lg:flex items-center gap-2">
            {/* SEARCHBAR */}
            <div className="w-full xl:w-searchBar lg:w-searchBar mt-2 xl:mt-0 lg:mt-0">
              <Input
                type="text"
                placeholder="Search your career"
                name="career"
                id="career"
                value={search}
                onChange={(event) => setSearch(event?.target?.value)}
              />
            </div>

            {/* STATUS DROPDOWN */}
            <div className="w-full xl:w-statusSelect lg:w-statusSelect mt-2 xl:mt-0 lg:mt-0">
              <Select
                options={status}
                classNamePrefix="dropdown"
                placeholder="Select status"
                name="status"
                id="status"
                value={selectedStatus}
                onChange={(e) => {
                  e?.value === "clear"
                    ? setSelectedStatus("")
                    : setSelectedStatus(e);
                }}
              />
            </div>

            {/* ADD career */}
            <Button
              className="w-full xl:w-auto lg:w-auto mt-2 xl:mt-0 lg:mt-0 bg-logoYellow rounded-lg py-3 px-8 text-sm font-proxima-semibold shadow-none hover:shadow-none normal-case hover:bg-opacity-80 transition-all duration-300 ease-in-out"
              onClick={() => {
                addCareerFormik.setFieldValue("career", null);
                setAddDialog(!addDialog);
              }}
            >
              Add Career
            </Button>
          </div>
        </div>

        {/* {careerList?.length === 0 && loading === true && (
          <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5 mt-3">
            <p className="text-base xl:text-lg lg:text-lg font-proxima-regular text-greyText tracking-tight text-center">
              Please wait we are fetching your careerList...
            </p>
          </div>
        )}
        {careerList?.length === 0 && loading === false && (
          <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5 mt-3">
            <p className="text-base xl:text-lg lg:text-lg font-proxima-regular text-greyText tracking-tight text-center">
              We were not able to find any careerList.
            </p>
          </div>
        )} */}

        {/* careerList LIST */}
        <div className="mt-5 xl:mt-10 lg:mt-10 grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 gap-5">
          {data?.map((data) => (
            <div className="col-span-1" key={data._id}>
              <CareerBox
                id={data._id}
                name={data.name}
                enabled={data.status === 1 ? true : false}
                details={data}
              />
            </div>
          ))}
        </div>
      </div>

      {careerList?.length > 0 && (
        <ReactPaginate
          className="lists-pagination"
          previousLabel={
            <Button className="list-pagination-btn">
              <GrPrevious color="#323232" size="20" />
            </Button>
          }
          nextLabel={
            <Button className="list-pagination-btn">
              <GrNext color="#323232" size="20" />
            </Button>
          }
          breakLabel={"..."}
          pageCount={totalPages}
          marginPagesDisplayed={3}
          pageRangeDisplayed={2}
          onPageChange={handlePageClick}
          activeClassName={"active"}
        />
      )}

      {/* ADD Career DIALOG */}
      <Dialog
        open={addDialog}
        handler={() => {
          addCareerFormik.setFieldValue("career", null);
          setAddDialog(!addDialog);
        }}
        size="xs"
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogBody className="p-0">
          <form onSubmit={addCareerFormik.handleSubmit}>
            <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-proxima-bold text-black tracking-tight">
                Add Career
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => {
                  addCareerFormik.setFieldValue("career", null);
                  setAddDialog(!addDialog);
                }}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
            <div className="p-5 border-b border-authBorder">
              {/* Career NAME */}
              <div className="form-group">
                <label className="text-sm font-proxima-semibold text-black">
                  Career Name <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    onChange={addCareerFormik.handleChange}
                    value={addCareerFormik.values.name}
                    error={
                      addCareerFormik.errors.name &&
                      addCareerFormik.touched.name
                        ? true
                        : false
                    }
                    placeholder="Write the career name"
                  />
                </div>
              </div>

              {/* Career Location */}
              <div className="form-group">
                <label className="text-sm font-proxima-semibold text-black">
                  Location <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <Input
                    type="text"
                    name="location"
                    id="location"
                    onChange={addCareerFormik.handleChange}
                    value={addCareerFormik.values.location}
                    error={
                      addCareerFormik.errors.location &&
                      addCareerFormik.touched.location
                        ? true
                        : false
                    }
                    placeholder="Write the location name"
                  />
                </div>
              </div>

              {/* DESCRIPTION */}
              <div className="form-group mt-2">
                <label className="text-sm font-proxima-semibold text-black">
                  Description <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <textarea
                    className={`block w-full px-5 py-3 rounded-lg border text-sm font-proxima-semibold text-black placeholder:text-sm placeholder:text-gray-500 placeholder:font-proxima-regular focus:outline-logoYellow ${
                      addCareerFormik.errors.description &&
                      addCareerFormik.touched.description
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                    placeholder="Write the career description here"
                    onChange={(e) => {
                      addCareerFormik.setFieldValue(
                        "description",
                        e.target.value
                      );
                    }}
                    value={addCareerFormik.values.description}
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end px-5 py-3">
              <Button
                disabled={addCareerFormLoading}
                type="submit"
                className="text-sm shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-5 py-3 rounded-md font-proxima-semibold text-white transition-all duration-300 ease-in-out normal-case"
              >
                {addCareerFormLoading ? "Please wait.." : "Save details"}
              </Button>
            </div>
          </form>
        </DialogBody>
      </Dialog>

      {/* EDIT CATEGORY DIALOG */}
      <Dialog
        open={editDialog}
        handler={() => setEditDialog(!editDialog)}
        size="xs"
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogBody className="p-0">
          <form onSubmit={addCareerFormik.handleSubmit}>
            <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-proxima-bold text-black tracking-tight">
                Edit Career
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setAddDialog(!addDialog)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
            <div className="p-5 border-b border-authBorder">
              {/* CATEGORY NAME */}
              <div className="form-group">
                <label className="text-sm font-proxima-semibold text-black">
                  Career Name <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    onChange={addCareerFormik.handleChange}
                    value={addCareerFormik.values.name}
                    error={
                      addCareerFormik.errors.name &&
                      addCareerFormik.touched.name
                        ? true
                        : false
                    }
                    placeholder="Write the career name"
                  />
                </div>
              </div>

              {/* CAREER LOCATION */}
              <div className="form-group">
                <label className="text-sm font-proxima-semibold text-black">
                  Location <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <Input
                    type="text"
                    name="location"
                    id="location"
                    onChange={addCareerFormik.handleChange}
                    value={addCareerFormik.values.location}
                    error={
                      addCareerFormik.errors.location &&
                      addCareerFormik.touched.location
                        ? true
                        : false
                    }
                    placeholder="Write the location name"
                  />
                </div>
              </div>

              {/* DESCRIPTION */}
              <div className="form-group mt-2">
                <label className="text-sm font-proxima-semibold text-black">
                  Description <span className="text-red-500">*</span>
                </label>
                <div className="mt-1">
                  <textarea
                    toolbar={{ options: ["inline", "link"] }}
                    className={`block w-full px-5 py-3 rounded-lg border text-sm font-proxima-semibold text-black placeholder:text-sm placeholder:text-gray-500 placeholder:font-proxima-regular focus:outline-logoYellow ${
                      addCareerFormik.errors.description &&
                      addCareerFormik.touched.description
                        ? "border-red-500"
                        : "border-gray-300"
                    }`}
                    wrapperClassName="text-editor-wrapper"
                    placeholder="Write the career description here"
                    onEditorStateChange={(e) => {
                      addCareerFormik.setFieldValue("description", e);
                    }}
                    editorState={addCareerFormik.values.description}
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end px-5 py-3">
              <Button
                disabled={addCareerFormLoading}
                type="submit"
                className="text-sm shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-5 py-3 rounded-md font-proxima-semibold text-white transition-all duration-300 ease-in-out normal-case"
              >
                {addCareerFormLoading ? "Please wait.." : "Save details"}
              </Button>
            </div>
          </form>
        </DialogBody>
      </Dialog>

      {/* DELETE CAREER DIALOG */}
      <Dialog
        open={deleteDialog}
        handler={() => setDeleteDialog(!deleteDialog)}
        size="xs"
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogBody className="p-0">
          <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
            <h5 className="text-lg font-proxima-bold text-black tracking-tight">
              Delete Career
            </h5>
            <Button
              className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
              onClick={() => setDeleteDialog(!deleteDialog)}
            >
              <IoClose className="w-4 h-4 text-greyText" />
            </Button>
          </div>
          <div className="p-5 border-b border-authBorder">
            <p className="text-base font-proxima-regular text-black">
              Are you sure you want to delete this career?
            </p>
          </div>
          <div className="flex items-center justify-end px-5 py-3">
            <Button className="text-sm shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-5 py-3 rounded-md font-proxima-semibold text-white transition-all duration-300 ease-in-out normal-case">
              Delete details
            </Button>
          </div>
        </DialogBody>
      </Dialog>

      {/* VIEW CATEGORY DIALOG */}
      <Dialog
        open={viewDialog}
        handler={() => setViewDialog(!viewDialog)}
        size="xs"
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogBody className="p-0">
          <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
            <h5 className="text-lg font-proxima-bold text-black tracking-tight">
              View Career
            </h5>
            <Button
              className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
              onClick={() => setViewDialog(!viewDialog)}
            >
              <IoClose className="w-4 h-4 text-greyText" />
            </Button>
          </div>
          <div className="p-5">
            <div className="flex items-center justify-between">
              <h5 className="text-lg font-proxima-bold text-black ">
                Name : {viewDetails && viewDetails?.name}
              </h5>
            </div>
            <div className="flex items-center justify-between">
              <h5 className="text-lg font-proxima-bold text-black ">
                Location : {viewDetails && viewDetails?.location}
              </h5>
            </div>
            <div className="mt-1">
              <p className="text-sm font-proxima-semibold text-greyText">
                Description :{" "}
                {ReactHtmlParser(viewDetails && viewDetails?.description)}
              </p>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </section>
  );
};

export default Career;
